<template>
  <div class="toggle-wrapper">
    <!-- Toggle Button (Visible on Mobile) -->
    <button
      class="btn btn-outline-secondary d-md-none m-2"
      type="button"
      @click="toggleSidebar"
    >
      ☰ Menu
    </button>

    <div v-if="isSidebarVisible" class="bg-light border-end p-3 sidebar">
      <ul class="nav flex-column">
        <button
          class="btn btn-outline-secondary d-md-none m-2"
          type="button"
          @click="toggleSidebar"
        >
          ☰ Menu
        </button>
        <li class="nav-item">
          <router-link class="nav-link" to="/dashboard">Dashboard</router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link" to="/books">Books</router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link" to="/orders">Orders</router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link" to="/categories">Categories</router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link" to="/request">Book Requests</router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link" to="/banners">Banners</router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link" to="/coupons">Coupons</router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link" to="/homepage-sections">Sections</router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link" to="/contact-form-submissions">Contact Form Submissions</router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link" to="/users">Users</router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "SideBar",
  data() {
    return {
      isSidebarVisible: true,
      isMobile: false,
    };
  },
  mounted() {
    this.checkViewport();
  },
  methods: {
    toggleSidebar() {
      this.isSidebarVisible = !this.isSidebarVisible;
    },
    checkViewport() {
      this.isMobile = window.innerWidth < 768;
      if (this.isMobile) {
        this.isSidebarVisible = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.toggle-wrapper {
  position: relative;
  top: 55px;
}
.sidebar {
  position: fixed;
  top: 55px;
  left: 0;
  width: 200px;
  height: 100%;
  z-index: 10;
  &.visible {
    display: block;
  }
  &.hidden {
    display: none;
  }
  .nav-link {
    color: #333;
    &:hover {
      background-color: #e2e6ea;
    }
  }
}
</style>
